import { useFeatureFlag } from '@lucidhq/ui-feature-flags';

export const useSplit = (flag: string) => {
  const { treatment } = useFeatureFlag(flag);

  return { isOn: treatment === 'on', isOff: treatment === 'off' };
};
